<script lang="ts">
    import Fa from 'svelte-fa'
    import {link,push} from 'svelte-spa-router'
    import * as qs from 'qs';
    import { faLine } from '@fortawesome/free-brands-svg-icons';
    import { faUserPlus,faHomeUser,faCircleRight,faMobileScreenButton,faMinus,faKey,faLock,faPiggyBank,faAddressCard,faUser,faLink } from '@fortawesome/free-solid-svg-icons';
    import Swal from 'sweetalert2'

    // let dataSetting = {
    //     background:"",
    //     gmzbuzzkey:"",
    //     homepage:"",
    //     isotp:0,
    //     lineid:"",
    //     lineurl:"",
    //     logo:"",
    //     telegram:"",
    //     title:""
    // }

    let dataSetting = JSON.parse(window.localStorage.getItem('setting'))
    
    let isotp = 1
    isotp = dataSetting.is_otp
        
    $:{ if(!dataSetting){
            setTimeout(() => {
                dataSetting = JSON.parse(window.localStorage.getItem('setting'))
                isotp = dataSetting.is_otp
                // alert(isotp)
            }, 1000);
        }
    }

    

    export let params = {};

    let customerhowtoknowusid = ""
    let showKnid = true
    $: {
        if (params && params.sid) {
            customerhowtoknowusid = params.sid
            window.localStorage.setItem("registerid",params.sid)
            showKnid = false
        }
    }

    if(window.localStorage.getItem('registerid')){
        if(window.localStorage.getItem('registerid')!=''){
            customerhowtoknowusid = window.localStorage.getItem('registerid')
            showKnid = false
        }
    }

    let affids = ""

    if(window.localStorage.getItem('aff')){
        if(window.localStorage.getItem('aff')!=''){
            if(dataSetting.affid!=""){
                affids = window.localStorage.getItem('aff').toString()
                customerhowtoknowusid = dataSetting.affid.toString()
                showKnid = false
            }else{
                affids = window.localStorage.getItem('aff')
            }
        }
    }

    let bankList = <any>[]
    let sourceList = <any>[]
    async function getBank() {
        const res = await fetch(window.localStorage.getItem("apiurl")+"register/bank", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({})
        })

        const json = await res.json()
        if (json.statusCode==200) {
            bankList = json.payload
			return json.payload;
		}else{
            return []
        }
    }
    $:{bankList = getBank()}
    async function getSource() {
        const res = await fetch(window.localStorage.getItem("apiurl")+"register/source", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({})
        })

        const json = await res.json()
        if (json.statusCode==200) {
            sourceList = json.payload
			return json.payload;
		}else{
            return []
        }
    }
    $:{sourceList = getSource()}

    

    let step1 = true
    let step2 = false
    let step3 = false
    let step4 = false

    let step4btn = true

    let otp1
    let otp2
    let otp3
    let otp4

    let username = ""
    let otp_num1 = ""
    let otp_num2 = ""
    let otp_num3 = ""
    let otp_num4 = ""

    let password = ""
    let password2 = ""

    let customerbankbankid = ""
    let customerbankaccnumber = ""
    let customername = ""
    let namedis = true

    // let customeringamepassword = ""
    let customerphone = ""
    let customersecrectcode = ""
    
    // let customerbankbankid = ""
    let customerbankaccname = ""

    async function getBankName() {
        const res = await fetch(window.localStorage.getItem("apiurl")+"register/checkbank", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({
                bank_code:customerbankbankid,
                bank_acc:customerbankaccnumber
            })
        })

        const json = await res.json()
        if (json.statusCode==200) {
            customername = json.payload
            namedis = true
			// return json.payload;
		}else{
            namedis = false
            customername = ""
            // return []
        }
    }
    function gotostep(stp) {
        step1 = false
        step2 = false
        step3 = false
        step4 = false
        if(stp==1){step1=true}
        if(stp==2){step2=true}
        if(stp==3){step3=true}
        if(stp==4){step4=true}
    }
    function isNumeric(n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
    }
    async function setStep1() {
        if(!isNumeric(customerphone)){
            Swal.fire({
                heightAuto: false,
                title: 'ไม่สามารถทำรายการได้',
                text: "กรุณาระบุตัวเลขเท่านั้น",
                icon: 'error',
                confirmButtonText: 'OK' 
            })
            return
        }
        const res = await fetch(window.localStorage.getItem("apiurl")+"register/step1", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({
                member_tel:customerphone,
                isotp:isotp
            })
        })

        const json = await res.json()
        if (json.statusCode==200) {
            if(isotp==0){
                gotostep(3)
            }else{
                gotostep(2)
            }
            window.localStorage.setItem("otp_token",json.payload.token)
		}else{
            Swal.fire({
                heightAuto: false,
                title: 'ไม่สามารถทำรายการได้',
                text: json.message,
                icon: 'error',
                confirmButtonText: 'OK' 
            })
        }
    }
    async function setStep2() {
        const res = await fetch(window.localStorage.getItem("apiurl")+"register/step2", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({
                token:window.localStorage.getItem("otp_token"),
                otp:otp_num1.toString()+otp_num2.toString()+otp_num3.toString()+otp_num4.toString()
            })
        })

        const json = await res.json()
        if (json.statusCode==200) {
            gotostep(3)
		}else{
            Swal.fire({
                heightAuto: false,
                title: 'ไม่สามารถทำรายการได้',
                text: json.message,
                icon: 'error',
                confirmButtonText: 'OK' 
            })
        }
    }
    async function setStep3() {
        if(password == "" || password2 == ""){
            Swal.fire({
                heightAuto: false,
                title: 'ไม่สามารถทำรายการได้',
                text: "กรุณาระบุรหัสผ่านให้ครบถ้วน",
                icon: 'error',
                confirmButtonText: 'OK' 
            })
            return
        }else{
            if(password!=password2){
                Swal.fire({
                    heightAuto: false,
                    title: 'ไม่สามารถทำรายการได้',
                    text: "รหัสผ่านไม่ตรงกัน",
                    icon: 'error',
                    confirmButtonText: 'OK' 
                })
                return
            }else{
                const res = await fetch(window.localStorage.getItem("apiurl")+"register/step3", {
                    method: 'POST',
                    headers:{
                        'Content-Type': 'application/x-www-form-urlencoded',
                'x-api-appid': window.localStorage.getItem("appid")
                    },
                    body: qs.stringify({
                        token:window.localStorage.getItem("otp_token"),
                        member_password:password
                    })
                })
                const json = await res.json()
                if (json.statusCode==200) {
                    gotostep(4)
                }else{
                    Swal.fire({
                        heightAuto: false,
                        title: 'ไม่สามารถทำรายการได้',
                        text: json.message,
                        icon: 'error',
                        confirmButtonText: 'OK' 
                    })
                }
            }
        }
    }
    async function setStep4() {
        step4btn = false
        if(customerbankbankid == ""){
            Swal.fire({
                heightAuto: false,
                title: 'ไม่สามารถทำรายการได้',
                text: "กรุณาระบุธนาคาร",
                icon: 'error',
                confirmButtonText: 'OK' 
            })
            step4btn = true
            return
        }
        if(customerbankaccnumber == ""){
            Swal.fire({
                heightAuto: false,
                title: 'ไม่สามารถทำรายการได้',
                text: "กรุณาระบุเลขที่บัญชี",
                icon: 'error',
                confirmButtonText: 'OK' 
            })
            step4btn = true
            return
        }
        if(!isNumeric(customerbankaccnumber)){
            Swal.fire({
                heightAuto: false,
                title: 'ไม่สามารถทำรายการได้',
                text: "กรุณาระบุ เลขที่บัญชี เป็นตัวเลขเท่านั้น",
                icon: 'error',
                confirmButtonText: 'OK' 
            })
            return
        }
        if(customername == ""){
            Swal.fire({
                heightAuto: false,
                title: 'ไม่สามารถทำรายการได้',
                text: "กรุณาระบุชื่อบัญชี",
                icon: 'error',
                confirmButtonText: 'OK' 
            })
            step4btn = true
            return
        }
        if(customerhowtoknowusid == ""){
            Swal.fire({
                heightAuto: false,
                title: 'ไม่สามารถทำรายการได้',
                text: "กรุณาระบุช่องทางที่รู้จักเรา",
                icon: 'error',
                confirmButtonText: 'OK' 
            })
            step4btn = true
            return
        }

        
        const res = await fetch(window.localStorage.getItem("apiurl")+"register/step4", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({
                token:window.localStorage.getItem("otp_token"),
                affid:affids,
                bankcode:customerbankbankid,
                member_acc:customerbankaccnumber,
                member_name:customername,
                source:customerhowtoknowusid,
                customeruuid:"",
                settingid:dataSetting._id
            })
        })
        const json = await res.json()
        if (json.statusCode==200) { 
            Swal.fire({
                heightAuto: false,
                title: 'สมัครสมาชิกสำเร็จ',
                text: "username : "+customerphone,
                icon: 'success',
                confirmButtonText: 'OK' 
            })
            let dataLogin = {
                password:password,
                web_id:window.localStorage.getItem("appid")
            }
            const xres = await fetch(window.localStorage.getItem("apiurl")+"auth/login", {
                method: 'POST',
                headers:{
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: qs.stringify({
                    username:customerphone,
                    password:JSON.stringify(dataLogin)
                })
            })
            const xjson = await xres.json()
            if (xjson.statusCode==200) {
                window.localStorage.setItem("access_token",xjson.access_token)
                push('/dashboard')
            }else{
                push("/auth")
            }
             
        }else{
            Swal.fire({
                heightAuto: false,
                title: 'ไม่สามารถทำรายการได้',
                text: json.message,
                icon: 'error',
                confirmButtonText: 'OK' 
            })
            step4btn = true
        }
    }

</script>

<div class="row pt-2">
    <div class="col-6">
        <a href="#" class="btn btn-outline-secondary btn-sm btn-gd" style="--bs-btn-padding-y: .10rem; --bs-btn-padding-x: .3rem; --bs-btn-font-size: .6rem;"><Fa icon={faHomeUser} /> หน้าหลัก</a>
    </div>
    <div class="col-6 text-end">
        <a href="{dataSetting.lineurl}" target="_blank"><span class="badge rounded-pill text-bg-success"><Fa icon={faLine} size="lg"/> {dataSetting.lineid}</span></a>
    </div>
    
    <div class="col-3 mt-2"></div>
    <div class="col-6 text-center mt-2">
        <img src="{dataSetting.logo}" class="img-fluid">
    </div>
    <div class="col-12 mt-3">
        <div class="card">
            <div class="card-body">
                {#if step1}
                <div class="row">
                    <div class="mb-3 text-center">
                        <span class="text-info"><Fa icon={faMinus}  size="2x"/></span>
                        <span class="text-secondary"><Fa icon={faMinus}  size="2x"/></span>
                        <span class="text-secondary"><Fa icon={faMinus}  size="2x"/></span>
                        <span class="text-secondary"><Fa icon={faMinus}  size="2x"/></span>
                    </div>
                    <!-- <div class="cf-turnstile" data-sitekey="0x4AAAAAAACLn-OIe36odM6b" data-callback="javascriptCallback"></div> -->
                    <div class="mb-3">
                        <label for="customerphone" class="form-label"><Fa icon={faMobileScreenButton} /> เบอร์โทร</label>
                        <input type="text" class="form-control rounded-pill text-center" id="customerphone" placeholder="" bind:value={customerphone}>
                    </div>
                    
                    <div class="col-12 text-center d-grid gap-2">
                        <button type="button" class="btn btn-dark rounded-pill btn-gd" on:click={() => setStep1()}  >ถัดไป <Fa icon={faCircleRight} /></button>
                    </div>
                </div>
                {/if}
                {#if step2}
                <div class="row">
                    <div class="mb-3 text-center">
                        <span class="text-success"><Fa icon={faMinus}  size="2x"/></span>
                        <span class="text-info"><Fa icon={faMinus}  size="2x"/></span>
                        <span class="text-secondary"><Fa icon={faMinus}  size="2x"/></span>
                        <span class="text-secondary"><Fa icon={faMinus}  size="2x"/></span>
                    </div>
                    <div class="mb-3">
                        <label for="exampleFormControlInput1" class="form-label"><Fa icon={faMobileScreenButton} /> OTP</label>
                        <div class="row">
                            <div class="col-3 p-1">
                                <input type="text" class="form-control rounded-pill text-center mobile-verify" maxlength="1" placeholder="" bind:value={otp_num1} bind:this={otp1} on:keyup={() => otp2.focus()}>
                            </div>
                            <div class="col-3 p-1">
                                <input type="text" class="form-control rounded-pill text-center mobile-verify" maxlength="1" placeholder="" bind:value={otp_num2} bind:this={otp2} on:keyup={() => otp3.focus()}>
                            </div>
                            <div class="col-3 p-1">
                                <input type="text" class="form-control rounded-pill text-center mobile-verify" maxlength="1" placeholder="" bind:value={otp_num3} bind:this={otp3} on:keyup={() => otp4.focus()}>
                            </div>
                            <div class="col-3 p-1">
                                <input type="text" class="form-control rounded-pill text-center mobile-verify" maxlength="1" placeholder="" bind:value={otp_num4} bind:this={otp4} >
                            </div>
                        </div>
                        
                        
                    </div>
                    <div class="col-12 text-center d-grid gap-2">
                        <button type="button" class="btn btn-dark rounded-pill btn-gd" on:click={() => setStep2()} >ถัดไป <Fa icon={faCircleRight} /></button>
                    </div>
                </div>
                {/if}
                {#if step3}
                <div class="row">
                    <div class="mb-3 text-center">
                        <span class="text-success"><Fa icon={faMinus}  size="2x"/></span>
                        <span class="text-success"><Fa icon={faMinus}  size="2x"/></span>
                        <span class="text-info"><Fa icon={faMinus}  size="2x"/></span>
                        <span class="text-secondary"><Fa icon={faMinus}  size="2x"/></span>
                    </div>
                    <div class="mb-3">
                        <label for="password" class="form-label"><Fa icon={faKey} /> รหัสผ่าน</label>
                        <input type="password" class="form-control rounded-pill text-center" id="password" placeholder="" bind:value={password} >
                    </div>
                    <div class="mb-3">
                        <label for="password2" class="form-label"><Fa icon={faLock} /> ยืนยันรหัสผ่าน</label>
                        <input type="password" class="form-control rounded-pill text-center" id="password2" placeholder="" bind:value={password2} >
                    </div>
                    <div class="col-12 text-center d-grid gap-2">
                        <button type="button" class="btn btn-dark rounded-pill btn-gd" on:click={() => setStep3()} >ถัดไป <Fa icon={faCircleRight} /></button>
                    </div>
                </div>
                {/if}
                {#if step4}
                <div class="row">
                    <div class="mb-3 text-center">
                        <span class="text-success"><Fa icon={faMinus}  size="2x"/></span>
                        <span class="text-success"><Fa icon={faMinus}  size="2x"/></span>
                        <span class="text-success"><Fa icon={faMinus}  size="2x"/></span>
                        <span class="text-info"><Fa icon={faMinus}  size="2x"/></span>
                    </div>
                    <div class="mb-3">
                        <label for="exampleFormControlInput1" class="form-label"><Fa icon={faPiggyBank} /> ธนาคาร</label>
                        <select class="form-select rounded-pill" aria-label="Default select example" bind:value={customerbankbankid}>
                            <option selected value="">กรุณาระบุธนาคาร</option>
                            {#await bankList}
                            {:then value}
                            {#each value as { bankAbbrevEn, bankAbbrevTh }, i}
                            <option value="{bankAbbrevEn}">{bankAbbrevTh}</option>
                            {/each}
                            {/await}
                          </select>
                    </div>
                    <div class="mb-3">
                        <label for="exampleFormControlInput1" class="form-label"><Fa icon={faAddressCard} /> เลขบัญชี</label>
                        <input type="text" class="form-control rounded-pill text-center" id="exampleFormControlInput1" placeholder="" bind:value={customerbankaccnumber} on:change={() => getBankName()}>
                    </div>
                    <div class="mb-3">
                        <label for="exampleFormControlInput1" class="form-label"><Fa icon={faUser} /> ชื่อบัญชี</label>
                        <input type="text" class="form-control rounded-pill text-center" id="exampleFormControlInput1" placeholder="" bind:value={customername} readonly={namedis}>
                    </div>
                    {#if showKnid}
                    <div class="mb-3">
                        <label for="exampleFormControlInput1" class="form-label"><Fa icon={faLink} /> รู้จักเราจาก</label>
                        <select class="form-select rounded-pill" aria-label="Default select example" bind:value={customerhowtoknowusid}>
                            <option selected value="">กรุณาระบุช่องทาง</option>
                            {#await sourceList}
                            {:then value}
                            {#each value as { _id, source_name }, i}
                            <option value="{_id}">{source_name}</option>
                            {/each}
                            {/await}
                          </select>
                    </div>
                    {/if}
                    <div class="col-12 text-center d-grid gap-2">
                        {#if step4btn}
                        <button type="button" class="btn btn-dark rounded-pill btn-gd"  on:click={() => setStep4()} >ถัดไป <Fa icon={faCircleRight} /></button>
                        {/if}
                    </div>
                </div>
                {/if}
                <div class="row">
                    
                    <div class="mt-3 mb-2" style="border-top: 0.5px solid rgba(52, 52, 52, 0.1);">
                        <div class="text-center mt-3 ">
                            <button on:click={() => push('/auth')} type="button" class="btn mr-2 btn-success rounded-pill btn-sm" style="--bs-btn-padding-y: .25rem; --bs-btn-padding-x: .5rem; --bs-btn-font-size: .75rem;"><Fa icon={faUserPlus} /> เข้าสู่ระบบ</button>
                            <button on:click={() => window.location.href = dataSetting.lineurl} type="button" class="btn btn-outline-secondary rounded-pill" style="--bs-btn-padding-y: .25rem; --bs-btn-padding-x: .5rem; --bs-btn-font-size: .75rem;"><Fa icon={faLine} size="lg"/> <span>ติดต่อเจ้าหน้าที่</button>
                        </div>
                    </div>
                </div>
            </div>
          </div>
    </div>
</div>
